import { getPartStyleFromStyleInterpolation } from '@frontend/legacy-components/src/theme/styleConfigHelpers';

import { INPUT_STYLE_CONFIG } from '../input/inputStyleConfig';
import type { PinInputStyleConfig } from './types';

const baseStyle: PinInputStyleConfig['baseStyle'] = ({ theme, colorMode }) => {
  const inputFieldStyles = getPartStyleFromStyleInterpolation(
    INPUT_STYLE_CONFIG.baseStyle,
    'field',
    { theme, colorMode },
  );

  return {
    ...inputFieldStyles,
    textAlign: 'center',
  };
};

const SIZES = {
  lg: {
    fontSize: 'lg',
    lineHeight: 'lg',
    w: 5,
    h: 5,
    borderRadius: 'sm',
    _notFirst: {
      ml: 1,
    },
  },
  md: {
    fontSize: 'md',
    lineHeight: 'md',
    w: 4,
    h: 4,
    borderRadius: 'sm',
    _notFirst: {
      ml: 0.75,
    },
  },
  sm: {
    fontSize: 'sm',
    lineHeight: 'sm',
    w: 3,
    h: 3,
    borderRadius: 'sm',
    _notFirst: {
      ml: 0.5,
    },
  },
} as const;

const { defaultProps } = INPUT_STYLE_CONFIG;

export const PIN_INPUT_STYLE_CONFIG: PinInputStyleConfig = {
  baseStyle,
  sizes: SIZES,
  defaultProps,
};
